export enum UserRole {
  Guest = 'guest',
  Operator = 'operator',
}

export function isUserRole(value: unknown): value is UserRole {
  return value === UserRole.Guest || value === UserRole.Operator;
}
